'use strict';

import BaseService from './base.service';

class SpendingsService extends BaseService {
    /* @ngInject */
    constructor(
        Spending,
        SegaUser
    ) {
        super(Spending, SegaUser);
        this.defaultOrder = 'createdAt DESC';
    }

    void(opts = {id: 0, reason: ''}) {
        return this.Model.void({
            id: opts.id,
            reason: opts.reason
        }).$promise;
    }
}

export default SpendingsService;
